<script>
import TabBar from './tab-bar'
export default {
  components: { TabBar },
  props: {
    panes: Array,
    onTabClick: Function
  },
  methods: {
    renderPanes() {
      return this._l(this.panes, (pane, index) => {
        pane.index = index + ''
        const tabName = pane.name || pane.index
        const tabLabel = pane.$slots.label || pane.label
        return (
          <div
            class={{
              'cp-tabs_nav-item': true,
              'cp-tabs_nav-item_active': pane.active
            }}
            on-click={() => this.onTabClick(tabName)}
            key={`tab-${tabName}`}
            id={`tab-${tabName}`}
            ref="tabs"
            refInFor
          >
            {tabLabel}
          </div>
        )
      })
    }
  },
  render() {
    return (
      <div class="cp-tabs_nav">
        {this.renderPanes()}
        <tab-bar tabs={this.panes} />
      </div>
    )
  }
}
</script>
